import { render, staticRenderFns } from "./SchedulePickupNotification.vue?vue&type=template&id=4b2376ac"
import script from "./SchedulePickupNotification.vue?vue&type=script&lang=js"
export * from "./SchedulePickupNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports